
import { defineComponent, h } from 'vue';
import { mapState } from 'vuex';
import { message } from 'ant-design-vue';
import HistoryIcon from '@/components/icons/HistoryIcon.vue';
import DownloadIcon from '@/components/icons/DownloadIcon.vue';
import DeleteIcon from '@/components/icons/DeleteIcon.vue';
import { getTemplateFile, importPartFile } from '@/api/apis';
import UploadTemplateMessage from './UploadTemplateMessage.vue';
import { mapActions } from 'vuex';

const excelFormat = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel'
];

export default defineComponent({
  name: 'UploadModal',
  components: {
    HistoryIcon,
    DownloadIcon,
    DeleteIcon
    // UploadTemplateMessage
  },
  data() {
    return {
      loading: false,
      excelFormat,
      visible: true,
      isCancel: true,
      file: null
    };
  },
  computed: {
    ...mapState(['lang'])
  },
  emits: ['after-close'],
  methods: {
    ...mapActions(['reloadMsg']),
    handleAfterClose() {
      this.$emit('after-close', this.isCancel);
    },
    // show previous data
    handlePreviousFile() {
      this.isCancel = false;

      this.visible = false;
    },
    async handleConfirm() {
      this.loading = true;

      const fd = new FormData();

      fd.append('file', this.file as any);

      // const res = await importPartFile({
      //   file: fd
      // });

      const res = await importPartFile(fd);

      if (res.success) {

        await this.reloadMsg();

        this.isCancel = false;
        this.visible = false;
      } else {
        message.error({
          content: h(UploadTemplateMessage, {
            message: this.$t(res.message),
            result: (res.result || []).join(','),
            showNum: false
          })
        });
      }

      this.loading = false;
    },
    async downloadTemplate() {
      await getTemplateFile(`${this.$t('shopping_cart.part_template')}.xlsx`, {
        type: 6,
        local: this.lang
      });
    },
    handleDeleteFile() {
      this.file = null;
    },
    handleFileChange(e) {
      const files = e.target.files || [];

      if (files.length > 0) {
        const file = files[0];

        if (excelFormat.includes(file.type)) {
          this.file = file;
        } else {
          message.warn(this.$t('shopping_cart.wrong_file_format'));
        }
      }

      e.target.value = '';
    }
  }
});
